import { Link, Outlet, ScrollRestoration } from 'react-router-dom';
import { NavBar } from './NavBar';
import { usePageTracking } from '@/features/analytics/usePageTracking';
import { CountryInterestPrompt } from '@/features/events/CountryInterestPrompt';

export function Layout() {
  // Lives here rather than in App: the layout is inside the router, so it can read the current
  // route. App wraps RouterProvider and has no location to observe.
  usePageTracking();

  return (
    <div className="layout">
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      {/* Back returns to where you were on the previous page, and a new page starts at the top.
          Searches opt out of the reset (preventScrollReset), because they change the page below
          the search bar and moving the reader would undo the point. */}
      <ScrollRestoration />
      <NavBar />
      <main className="layout__main" id="main">
        <Outlet />
      </main>
      <footer className="layout__footer">
        {/* No description or "run one?" line here any more: the header carries what the site is,
            and the organiser invitation is a card at the top of the events page. Three places
            saying the same thing was the clutter. */}
        {/* The build version is not published here at all, in any form. It told a visitor nothing
            and told everyone else which commit is deployed — and the meta tag that used to carry
            it was worse than the visible line, because it looked like it had been removed while
            still being one view-source away.

            It is still on the admin panel, where the audience is operators, and `docker inspect`
            answers the same question on the box. */}
        <CountryInterestPrompt />

        {/* On every page, because the privacy notice has to be reachable wherever someone might
            hand over an email address — and that's the sign-in box, the submission form and the
            alert prompt, which is to say most of the site.

            These two links are also what keeps the company's trading disclosures satisfied now the
            registered name has come out of the footer: regulation 25 requires the registered name,
            place of registration, number and registered office to be on the website, not on every
            page of it, and both linked pages carry all four. Removing either link would take the
            site out of compliance as well as out of reach. */}
        <nav className="layout__legal" aria-label="Legal">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </footer>
    </div>
  );
}
